/* eslint-disable react/display-name */
import React, { forwardRef } from 'react'
import { createUseStyles } from 'react-jss'
import DatePicker from 'react-datepicker'

import SVG from '../../SVG/SVG'

const useStyles = createUseStyles(theme => ({
  dateTimeSelect: {
    alignItems: 'center',
    border: 'none',
    backgroundColor: theme.colors.white,
    color: theme.colors.blue,
    cursor: 'pointer',
    display: 'flex',
    padding: '7px 11px',
    borderRadius: theme.borderRadius,
    // justifyContent: "center",
    justifyContent: 'flex-start',
    minWidth: 250,
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  date: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  time: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  calendar: {
    marginRight: 11,
    position: 'relative',
    bottom: -1,
  },
  clock: {
    marginRight: 10,
    position: 'relative',
    bottom: -1,
  },
  text: {
    fontFamily: 'ITC Avant Garde',
    fontWeight: 400,
    fontSize: 13,
    fontWeight: 'normal',
    position: 'relative',
    bottom: 0,
    color: theme.colors.brushedsteel,
  },
  spacer: {
    display: 'block',
    content: '',
    height: 18,
    width: 1,
    backgroundColor: theme.colors.brushedsteel,
    marginLeft: 11,
    marginRight: 18,
  },
  modifiers: {
    fontFamily: 'ITC Avant Garde',
    fontWeight: 400,
    borderRadius: theme.borderRadius,
    border: 'none',
    boxShadow: '0 5px 11px 0 rgba(0,0,0,0.08)',
    '& .react-datepicker__header': {
      background: 'white',
      borderBottom: 'none',
    },
    '& .react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header': {
      color: theme.colors.blue,
      fontSize: 16,
      fontWeight: 'bold',
      letterSpacing: '.62px',
      lineHeight: '19px',
    },
    '& .react-datepicker__current-month, .react-datepicker-time__header': {
      lineHeight: '31px',
      marginBottom: 5,
    },
    '& .react-datepicker__navigation': {
      top: 16,
    },
    '& .react-datepicker__navigation--next': {
      borderLeftColor: theme.colors.deepsea,
    },
    '& .react-datepicker__navigation--previous': {
      borderRightColor: theme.colors.deepsea,
    },
    '& .react-datepicker__month-container': {
      paddingRight: 5,
    },
    '& .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button)': {
      right: 100,
    },
    '& .react-datepicker__day, .react-datepicker__month-text, .react-datepicker__quarter-text': {
      // color: "#C8C8C8"
      color: '#000',
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item': {
      // color: "#C8C8C8",
      color: '#000',
      height: 20,
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled': {
      // color: "#C8C8C8",
      color: '#CCC',
    },
    '& .react-datepicker__day--disabled, .react-datepicker__month-text--disabled, .react-datepicker__quarter-text--disabled, .react-datepicker__year-text--disabled': {
      color: '#C8C8C8',
    },
    '& .react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover, .react-datepicker__month-text--selected:hover, .react-datepicker__month-text--in-selecting-range:hover, .react-datepicker__month-text--in-range:hover, .react-datepicker__quarter-text--selected:hover, .react-datepicker__quarter-text--in-selecting-range:hover, .react-datepicker__quarter-text--in-range:hover': {
      background: theme.colors.sunflower,
      color: theme.colors.coal,
    },
    '& .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range': {
      borderRadius: 0,
      background: theme.colors.sunflower,
      color: theme.colors.coal,
    },
    '& .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected': {
      background: theme.colors.sunflower,
      color: theme.colors.coal,
    },
    '& .react-datepicker__day-name': {
      color: theme.colors.stormcloud,
      fontSize: 14,
      lineHeight: '16px',
      letterSpacing: '0.54px',
      fontWeight: 300,
    },
  },
}))

// const DateTimeSelect = ({ date, time }) => {
const DateTimeSelect = props => {
  const classes = useStyles()
  // const [startDate, setStartDate] = useState(new Date());

  // eslint-disable-next-line no-unused-vars
  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button onClick={onClick} className={classes.dateTimeSelect}>
      <span className={classes.date}>
        <span className={classes.text}>{value ? value : 'Select a date and time'}</span>
      </span>
    </button>
  ))

  const disableDays = date => {
    const { filterDate } = props

    console.log('filterDate', filterDate)

    if (!filterDate) return false

    const day = date.toLocaleDateString('en', { weekday: 'long' }).toLowerCase()
    const dbDays = filterDate.map(({ day }) => day)
    return dbDays.includes(day)
  }

  // console.log('\n\n\n-------------------------\n\n\n')
  // console.log(props.name)
  // console.log(props.minDate)
  // console.log(props.maxTime)
  // console.log('\n\n\n-------------------------\n\n\n')

  return (
    <DatePicker
      name={props.name}
      filterDate={disableDays}
      selected={props.date}
      onChange={date => props.onDateChange(date)}
      minDate={props.minDate}
      showTimeSelect
      showMonthDropdown
      showYearDropdown
      useShortMonthInDropdown
      // withPortal
      timeFormat="HH:mm"
      timeIntervals={30}
      timeCaption="Time"
      dateFormat="d MMMM yyyy | h:mm aa"
      customInput={<CustomInput />}
      calendarClassName={classes.modifiers}
      minTime={props.minTime}
      maxTime={props.maxTime}
    />
  )
}

// DateTimeSelect.propTypes = {
//   date: PropTypes.string,
//   time: PropTypes.string,
// }

export default DateTimeSelect
